/* eslint-disable @typescript-eslint/no-explicit-any */

import {
  ApolloLink,
  FetchResult,
  NextLink,
  Observable,
  Operation,
} from "@apollo/client";
import { OperationDefinitionNode } from "graphql";
import { logger } from "../logger.config";

export type LoggingCallback = (
  operation: Operation,
  forward: NextLink,
  error?: unknown
) => void;

export const Handler = (callback: LoggingCallback): ApolloLink =>
  new ApolloLink(
    (operation, forward) =>
      new Observable((observer) => {
        const sub = forward(operation).subscribe({
          next: (result) => {
            observer.next(result);
          },
          error: (networkError) => {
            callback(operation, forward, networkError);
            observer.error(networkError);
          },
          complete: () => {
            observer.complete();
          },
        });

        return () => {
          if (sub) {
            sub.unsubscribe();
          }
        };
      })
  );

export class LoggingLink extends ApolloLink {
  private link: ApolloLink;

  constructor(callback: LoggingCallback) {
    super();
    this.link = Handler(callback);
  }

  public request(
    operation: Operation,
    forward: NextLink
  ): Observable<FetchResult> | null {
    return this.link.request(operation, forward);
  }
}

const createApolloLog = (operation: Operation, data?: unknown): void => {
  const { operationName, query, variables } = operation;
  const operationType = (query.definitions[0] as OperationDefinitionNode)
    .operation;
  const message = `${operationType} | FAILED | ${operationName}`;

  logger.error(message, { operationName, variables, error: data });
};

/* istanbul ignore next */
export const loggingLink = new LoggingLink((operation, forward, error) => {
  if (error) {
    createApolloLog(operation, error);
  }

  return forward(operation);
});
